import Pending from './ml-screens/pending/pending'
import Expired from './ml-screens/expired/expired.container'
import PrentPemrissionApproved from './ml-screens/parent-permission/approved/approved'
import PrentPemrissionDisapproved from './ml-screens/parent-permission/disapproved/disapproved.container'
import InvalidLink from './ml-screens/invalid-link/invalid-link'
import GenericError from './ml-screens/generic-error/generic-error.container'
import LinkResent from './ml-screens/link-resent/link-resent'
import EmailChanged from './ml-screens/email-changed/email-changed'

export default {
  pending: Pending,
  error_expired: Expired,
  error_invalid_token: InvalidLink,
  parent_approved: PrentPemrissionApproved,
  parent_disapproved: PrentPemrissionDisapproved,
  error_unknown: GenericError,
  link_resent: LinkResent,
  email_changed: EmailChanged
}
